var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "m-small" },
      [
        _vm._l(_vm.activeMenuItems, function (item, index) {
          return [
            _vm.checkPermission(item, "auth")
              ? _c(
                  "li",
                  { key: index },
                  [
                    _c("router-link", { attrs: { to: { name: item.route } } }, [
                      _c("i", { class: item.icon }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t(item.text)))]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }